export enum LoadingFlag {
    GetUserProfile = 'getUserProfile',
    UpdateUserProfile = 'updateUserProfile',
    DeleteUserProfile = 'deleteUserProfile',
    AuthChallenge = 'authChallenge',
    UnsubscribeChannel = 'unsubscribeChannel',
    GetChannels = 'getChannels',
    GetChannel = 'getChannel',
}
